export interface IBankingDetails {
  payment_frequency?: string;
  financial_institution?: string;
  branch_name?: string;
  branch_code?: string;
  account_number?: string;
  account_holder?: string;
  collection_day?: number;
}

export interface IBank {
  bankName: string; //official Brolink bank key
  code: string; //branch code - if empty it does not exist
  display: string; //prety TakeCtrl name replacement
  name: string; //the branch name - empty if code is empty
  miwayBankIdNo: string;
  miwayBankName: string;
  miwayBranchCode: string;
  miwayBranchName: string;
}

export interface IPremiaBankingDetails {
  account_holder: string;
  account_number: string;
  bank_code: string;
  bank_description: string;
  branch_code: string;
  branch_description: string;
  account_type_code: string;
  account_type_description: string;
  account_relationship_code: string;
  account_relationship_description: string;
  quotes_id: number;
}

export interface IPremiaLOV {
  code: string;
  description: string;
}
